import React from 'react';
import { useQuery } from 'react-query';

import { getIncentives } from 'apis/CommunityAPI';
import { IncentivesTable } from 'components/Alerts/AlertsIncentivesTable';
import ErrorMessage from 'components/lib/ErrorMessage';
import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';

import MyCommunitiesDetailsModal from './MyCommunitiesDetailsModal';

const ACTIVE_INCENTIVE_STATUS = 1;

type Props = {
  communityId: number;
  communityName: string;
  timePeriodLabel: string;
  timePeriodDays: number;
  onClose: () => void;
};

const CompetitorIncentivesModal = ({ communityId, communityName, timePeriodLabel, timePeriodDays, onClose }: Props) => {
  const {
    data = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['my-communities-competitor-incentives', communityId, timePeriodDays],
    queryFn: () => getIncentives(communityId, { status: ACTIVE_INCENTIVE_STATUS, days: timePeriodDays }),
    select: (incentives: any[]) =>
      incentives.filter((incentive) => incentive.community_type === COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR),
    enabled: Boolean(communityId),
    refetchOnWindowFocus: false,
  });

  return (
    <MyCommunitiesDetailsModal
      open
      onClose={onClose}
      title={communityName}
      subtitle={`Competitor incentives added in the ${timePeriodLabel.toLowerCase()}`}
    >
      <ErrorMessage text="Failed to load competitor incentives. Please try again." active={isError} />
      <IncentivesTable rows={data} loading={isLoading} showCompetitor />
    </MyCommunitiesDetailsModal>
  );
};

export default CompetitorIncentivesModal;
